import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c9cbc46c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sp-pa-body-item"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "8px",
    "height": "8px",
    "aspect-ratio": "1/1",
    "border-radius": "8px",
    "background": "#DDE1E6"
  }
};
const _hoisted_3 = {
  class: "sp-pa-info"
};
const _hoisted_4 = {
  class: "sp-pa-name"
};
const _hoisted_5 = {
  class: "pa-asin-sku"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_ppc_inconsistent_state_popover = _resolveComponent("ppc-inconsistent-state-popover");
  const _component_ppc_b_a_state_cell = _resolveComponent("ppc-b-a-state-cell");
  const _component_image_element = _resolveComponent("image-element");
  const _component_wrap_with_copy = _resolveComponent("wrap-with-copy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["sp-pa-state", {
      loading: $data.loading
    }])
  }, [$data.loading ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createBlock(_component_ppc_b_a_state_cell, {
    key: 1,
    state: $options.productAdState,
    onStateChange: _cache[2] || (_cache[2] = val => {
      $options.onStateChange(val ? 'ENABLED' : 'PAUSED');
    }),
    item_id: `enabled${$props.item.product_ad_group_id}`
  }, {
    default: _withCtx(() => [_createVNode(_component_ppc_inconsistent_state_popover, {
      type: "product ads",
      onPauseAll: _cache[0] || (_cache[0] = $event => $options.onStateChange('PAUSED')),
      onEnableAll: _cache[1] || (_cache[1] = $event => $options.onStateChange('ENABLED'))
    })]),
    _: 1
  }, 8, ["state", "item_id"]))], 2), _createElementVNode("div", {
    class: _normalizeClass(["sp-pa-image-and-info", {
      dot: $props.item.asin_image === 'dot'
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["sp-pa-image", {
      hasNext: $props.item.nextItemSame,
      dot: $props.item.asin_image === 'dot',
      only: !$props.item.nextItemSame && $props.item.asin_image !== 'dot'
    }])
  }, [$props.item.asin_image === 'dot' ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : (_openBlock(), _createBlock(_component_image_element, {
    key: 1,
    image: $props.item.asin_image === '' ? null : $props.item.asin_image,
    link: $options.navigateToLink(),
    width: 32,
    height: 32,
    withOverlay: ""
  }, null, 8, ["image", "link"]))], 2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($options.truncateString($props.item.asin_name, 75)), 1), _createElementVNode("div", _hoisted_5, [_createVNode(_component_wrap_with_copy, {
    size: 12
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.item.asin && $props.item.sku ? `${$props.item.asin} - ${$props.item.sku}` : $props.item.asin ? `${$props.item.asin}` : `${$props.item.sku}`), 1)]),
    _: 1
  })])])], 2)]);
}